export default __webpack_public_path__ + "assets/lab1.1dc2593a.png";